import styled from "styled-components"

export const Container = styled.div`
  flex: 1;
  .dates{
    font-size: .75rem;
    margin-bottom: 20px;
    display:block;
  }
`